/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: constants
 *
 * Created by rwilliams on 8/8/17.
 */
'use strict';
angular.module('prism-ui.components.constants', [])
    .value('VALID_FILE_EXTENSIONS', {
        ADPOD: ['csv'],
        AUDIO: ['aif', 'aiff', 'mp3', 'mov', 'wav'],
        CC: ['cca', 'scc', 'mcc', 'cap', 'sml', 'srt', 'xml', 'vtt', 'asc', 'dfxp', 'itt'],
        SUBTITLE: ['cca', 'scc', 'mcc', 'cap', 'sml', 'srt', 'xml', 'vtt', 'asc', 'dfxp', 'itt'],
        IMAGE: ['jpg', 'jpeg', 'tiff', 'png'],
        OTHER: ['jpg', 'jpeg', 'tiff', 'png'],
        RATING_OVERLAY: ['jpg', 'jpeg', 'tiff', 'png'],
        VIDEO: ['mov', 'mp4', 'wmv', 'avi', 'webm', 'flv', 'mxf', 'mpg', 'mpeg', 'm2t', 'm2ts', 'ts']
    })
    .value('_', window._)
    .value('Timecode', window.tmcd)
    .value('BRAND_ASSET_MAP_TYPES', {
        watermarks: 'VIDEO',
        breakPrePostRolls: 'VIDEO',
        preRolls: 'VIDEO',
        postRolls: 'VIDEO',
        artwork: 'OTHER',
        audios: 'AUDIO',
        ratingOverlays: 'VIDEO'
    }).value('MEDIA_INFO_AUDIO_CHANNEL_ASSIGNMENT', [
    {name: 'Center', value: 'C'},
    {name: 'Left', value: 'L'},
    {name: 'LFE', value: 'LFE'},
    {name: 'Left Surround', value: 'Ls'},
    {name: 'Left Total', value: 'Lt'},
    {name: 'Right', value: 'R'},
    {name: 'Right Surround', value: 'Rs'},
    {name: 'Right Total', value: 'Rt'}]
);
